import GenericAction from '@Actions/generic-action';
import { Actions } from '@Context/common/general/context';
import { AnalyticsEvents } from '@Enums';
import { confirmPasswordReset, getAuth } from 'firebase/auth';
export default class ConfirmPasswordReset extends GenericAction {
  runAction() {
    // Confirm password has beed reset using Firebase Auth
    const Action = async () => {
      try {
        await confirmPasswordReset(getAuth(),this._payload.code, this._payload.newPassword);
        super.onSuccess()
        this._dispatch({
          type: Actions.AppActions.AnalyticsEvent,
          payload: { type: AnalyticsEvents.user_password_reset_confirmed }
        });
        return Promise.resolve();
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}